<template>
  <b-container fluid style="background-color: white">
    <div class="text-center mx-auto p-4 mt-4">
      <span class="h4 text-warning font-weight-bold mt-4">¡Escoge el mejor plan para ti!</span>
      <b-row class="mt-4">
        <b-col :lg="12/plans.length" class="p-4" v-for="(plan, i) of plans" :key="plan.id" :class="{active: selected===i}">
          <b-card body-bg-variant="light" :header-bg-variant="plan.color" style="cursor:pointer;" @click="selected=i">
            <template v-slot:header>
                <h5 class="my-1 text-light text-uppercase font-weight-bold" >{{plan.name}}</h5>
            </template>
            <b-card-body class="p-0">
              <b-card-title class="h1 font-weight-bold" :class="`text-${plan.color}`">{{plan.price}}</b-card-title>
              <b-card-sub-title class="h6 text-dark">{{plan.period}}</b-card-sub-title>
              <hr :class="`border-${plan.color}`">
              <b-table-simple class="text-left text-muted p-1 rounded" borderless responsive>
                <b-tr v-for="(Sperk, index) in plan.specialPerks" :key="index+'-sperk'">
                  <b-td class="align-middle" :class="`text-${plan.color}`"><v-icon name="check"></v-icon></b-td>
                  <b-td class="text-muted"><div v-html="Sperk"></div></b-td>
                </b-tr>
                <b-tr v-for="(perk, index) in plan.perks" :key="index+'-perk'">
                  <b-td class="align-middle" :class="`text-${plan.color}`"><v-icon name="check"></v-icon></b-td>
                  <b-td class="text-muted">{{perk}}</b-td>
                </b-tr>
              </b-table-simple>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <!--
            Decía "Comprar!" y no tenía @click: era decoración. Un contrato de
            hasta $3.000.000 al año no se compra con un clic y no existe ningún
            flujo que lo permita, así que el botón dice lo que de verdad hace.
            Baja por JavaScript y no con href="#subscribe": /comprar/ usa
            router de hash, y un ancla le cambiaría la ruta.
          -->
          <b-button variant="primary" pill @click="irAlFormulario">
            Pedir cotización
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { event } from "vue-gtag";

export default {
  name: "Pricing",
  props: {
    route: {
      type: String,
      required: false
    }
  },
  data(){
    return {
      selected: -1,
      plans: [
        {
          id: 1,
          name: 'Facturación Anual',
          price: 'CLP $30.000 anual por estudiante',
          period: '',
          color: 'danger',
          perks: [
              'Capacitación al equipo sobre el uso de la plataforma.',
              'Teléfonos de contacto y servicio post-venta para solucionar dudas.',
              'Carga de todos los datos del colegio, cursos, estudiantes, usuarios y plantillas de documentos.',
              'Nuevas funcionalides y actualizaciones periódicas'
          ],
          specialPerks: [
            '<span style="font-size: 20px;">CLP $30.000 anual por estudiante ingresado a PIE/Escuela especial <strong>(con un monto tope a pagar de $3.000.000 anuales, sobre 100 estudiantes seguirá pagando lo mismo)</strong>.</span>',
          ]
        },
        // {
        //   id: 1,
        //   name: 'Facturación Mensual',
        //   price: 'CLP $2400 mensual por estudiante',
        //   period: ' ',
        //   color: 'info',
        //   perks: [
        //       'Capacitación al equipo sobre el uso de la plataforma.',
        //       'Teléfonos de contacto y servicio post-venta para solucionar dudas.',
        //       'Carga de todos los datos del colegio, cursos, estudiantes, usuarios y plantillas de documentos.',
        //       'Nuevas funcionalides y actualizaciones periódicas'
        //   ],
        //   specialPerks: [
        //       '<span style="font-size: 20px;">CLP $2400 mensual por estudiante ingresado a PIE/Escuela Especial. <strong>Sin Tope</strong>.</span>',
        //   ]
        // },
        // {
        //   id: 2,
        //   name: 'Plan Plata',
        //   price: '$70.000',
        //   period: 'mensuales',
        //   color: 'warning',
        //   perks: [
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //   ],
        // },{
        //   id: 3,
        //   name: 'Plan Oro',
        //   price: '$700.000',
        //   period: 'anual',
        //   color: 'info',
        //   perks: [
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //       'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed sit',
        //   ],
        // }
      ]
    }
  },
  methods: {
    irAlFormulario() {
      // Este boton es la superficie del `Lead` que Meta optimiza: en la
      // pagina institucional, pedir una cotizacion es la conversion, no
      // comprar. Se mide al pulsarlo y no al enviar el formulario porque
      // son dos gestos distintos y el que baja el embudo es este.
      //
      // `producto: "pie"` a mano y no desde la ruta: /comprar/#/ llama
      // "redpie" a esta pagina, y la clave del producto es "pie" en todo
      // el resto del sistema. La traduccion vive en services/origen.js.
      //
      // OJO: esto es GA4, no Meta. El pixel no entra al SPA (ver la regla
      // de alcance), asi que el `Lead` que Meta va a ver por esta
      // solicitud sale del servidor por la Conversions API.
      //
      // `origen_lead` y no `source`: GA4 se reserva ese nombre para la fuente
      // de campana, asi que un evento con `source: "pricing"` le dice a la
      // sesion que vino de una campana llamada "pricing" y le borra el anuncio
      // que la trajo de verdad. Los cinco nombres reservados estan en
      // backend/marketing/analitica.py (PARAMETROS_RESERVADOS).
      event("generate_lead", { producto: "pie", origen_lead: "pricing" });
      const destino = document.getElementById("subscribe");
      if (destino) {
        destino.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
}
</script>

<style scoped>
.active {
  border: #e0a800 3px solid;
  border-radius: 10px;
}
</style>